import React, { ReactNode } from "react";
import styles from "./hint-title.module.scss";

interface HintTitlePropTypes {
  text: string | ReactNode;
}

export const HintTitle = ({ text }: HintTitlePropTypes) => {
  return <p className={styles.hinttitle}>{text}</p>;
};
